import { getPageUrl } from '@/utils/helpers';

import resolveBlacklistUrls from './resolveBlacklistUrls';
import resolveCompound from './resolveCompound';
import resolveCRMSyncs from './resolveCRMSyncs';
import resolveRTC from './resolveRTC';
import { resolveAsset } from '@/utils/resolvers/index';

const getPageUrlCustom = ({ url = '', page }: { url?: string; page: any }) => {
  // Jumplinks allowed.
  if (/^#/.test(url)) return url;

  const QUERYPARAM_SEPARATOR = '?';
  const [rawBaseUrl, rawQueryParams] = url.split(QUERYPARAM_SEPARATOR);
  const baseUrl = getPageUrl({ url: rawBaseUrl, page });

  if (!rawQueryParams) return baseUrl;

  return [baseUrl, rawQueryParams].join(QUERYPARAM_SEPARATOR);
};

const resolveLink = ({ rawVal, page, pageModels }: PropsWithCMSProps<LinkProps>) => {
  const {
    displayText,
    openInNewWindow,
    link: ref,
    url,
    buttonStyle,
    visibility,
  } = resolveCompound<LinkCompound>({
    rawVal,
  });
  const content = ref && page?.getContent(ref);
  const isAsset = (content as any)?.type === 'asset';
  const data = isAsset ? undefined : content?.getData();
  const contentUrl = isAsset ? resolveAsset({ rawVal: ref, page })?.url : content?.getUrl();
  const isPageUrl = !!url && !!page;
  const href = isPageUrl ? getPageUrlCustom({ url, page }) : contentUrl;
  let marketoLink: MarketoFormLink = {};

  if (data?.hasOwnProperty('marketoFormId') && page && pageModels) {
    const { config, labels } = pageModels || {};
    const { marketo: marketoConfig } = config || {};
    const { marketo: marketoLabels = {} } = labels || {};
    const {
      base_url: baseUrl,
      munchkin_id: munchkinId,
      recaptcha_sitekey: recaptchaSitekey,
      recaptcha_legal: recaptchaLegal,
      email_fieldname: emailFieldname,
      email_blacklist_error_message: emailBlacklistErrorMessage,
      email_crm_fieldname: emailCRMFieldname,
    } = marketoConfig || {};

    marketoLink = {
      formId: data.marketoFormId,
      rules: data.rules,
      confirmationMessage: resolveRTC({ rawVal: data.confirmationMessage }),
      munchkinId,
      recaptchaLegal,
      baseUrl,
      recaptchaSitekey,
      heading: data.heading,
      formDescription: resolveRTC({ rawVal: data.description }),
      emailFieldname,
      emailBlacklistErrorMessage,
      emailsBlacklisted: resolveBlacklistUrls({ rawVal: data.emailBlacklistUrls }),
      emailCRMFieldname,
      CRMSyncFieldnames: resolveCRMSyncs<ICRMSyncFieldnames>({ rawVal: data.crmSyncs }),
      labels: marketoLabels,
    };
  }

  return { displayText, href, openInNewWindow, buttonStyle, marketoLink, visibility } as LinkType;
};

export default resolveLink;
